import { StrictMode } from 'react';
import { preconnect } from 'react-dom';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import * as TanStackQueryProvider from './integrations/tanstack-query/RootProvider';
import { ENV } from '@/config/env';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

import './styles.css';
import reportWebVitals from './reportWebVitals.ts';

// Create a new router instance
const router = createRouter({
  scrollToTopSelectors: ['#scroll-to-top'],
  routeTree,
  context: {
    ...TanStackQueryProvider.getQueryClient(),
  },
  defaultPreload: 'intent',
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.querySelector('#app');
if (!rootElement) {
  throw new Error('Root element #app not found');
}

// Only render if element is empty (prevent double rendering)
if (!rootElement.innerHTML) {
  const apiUrl = ENV.API_URL;
  if (apiUrl) {
    preconnect(apiUrl);
  }
  
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  root.render(
    <StrictMode>
      <TanStackQueryProvider.Provider>
        <RouterProvider router={router} />
      </TanStackQueryProvider.Provider>
    </StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(import.meta.env.DEV ? console.log : () => {});
